import React from 'react';

const Success = () => {
    return (
        <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g >
                <path d="M52 104C80.7188 104 104 80.7188 104 52C104 23.2812 80.7188 0 52 0C23.2812 0 0 23.2812 0 52C0 80.7188 23.2812 104 52 104Z" fill="#77CC00"/>
                <path d="M103.443 59.6376C100.573 79.1376 86.8806 95.1113 68.6664 101.278L22.2686 54.8723L32.3232 44.8176L43.5256 56.0219L71.6767 27.8708L103.443 59.6376Z" fill="url(#paint0_linear_1336_13677)"/>
                <path d="M81.7314 37.9235L53.5803 66.0766L52 67.6569L43.5256 76.1293L33.4709 66.0766L22.2686 54.8723L32.3232 44.8176L43.5256 56.0219L52 47.5476L71.6767 27.8708L81.7314 37.9235Z" fill="#FFF5F5"/>
            </g>
            <defs>
                <linearGradient  id="paint0_linear_1336_13677" x1="41.3704" y1="35.7704" x2="91.5687" y2="85.9687" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#288900"/>
                    <stop offset="1" stop-color="#288900" stop-opacity="0"/>
                </linearGradient>
                <clipPath id="clip0_1336_13677">
                    <rect width="104" height="104" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default Success;